<template>
  <v-container fluid>
    <input
      ref="excel-upload-input"
      class="excel-upload-input"
      type="file"
      accept=".xlsx, .xls"
      @change="handleClick"
    />
    <div class="drop" @drop="handleDrop" @dragover="handleDragover" @dragenter="handleDragover">
      Arroja aqui tus archivos excel o búscalo en tu ordenador
      <v-btn :loading="loading" @click="handleUpload" flat color="dark" icon>
        <v-icon>search</v-icon>
      </v-btn>
    </div>

    <v-card class="mt-3" flat style="border-radius: 0">
      <v-card-text class="pt-0 pb-0">
        <v-layout row wrap>
          <v-flex sm6>
            <h5 style="display: inline-block;" class="mt-3">Nueva data ATM | Permisos</h5>
            <v-tooltip bottom color="success">
              <template v-slot:activator="{ on }">
                <v-btn flat icon color="success" v-on="on" :loading="loading" @click="save()">
                  <v-icon>cloud_upload</v-icon>
                </v-btn>
              </template>
              <span>Guardar registros</span>
            </v-tooltip>
          </v-flex>
          <v-flex sm6>
            <v-text-field append-icon="search" label="Buscar..." v-model="search"></v-text-field>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
    <v-data-table
      :headers="dataTable.headers"
      :items="excelData.results"
      :search="search"
      :loading="listLoading"
    >
      <template v-slot:items="props">
        <td>{{ props.item.agent_id }}</td>
        <td>{{ props.item.num }}</td>
        <td>{{ props.item.type }}</td>
        <td>{{ props.item.sign_type }}</td>
        <td>{{ props.item.date | formatDate}}</td>
        <td>{{ props.item.attachment }}</td>
        <td>{{ props.item.exp_date | formatDate}}</td>
        <td>{{ props.item.status }}</td>
        <td>{{ props.item.observations }}</td>
      </template>
    </v-data-table>

    <v-snackbar v-model="snackbar.show" :color="snackbar.color" bottom right :timeout="2000">
      <v-icon>{{ snackbar.icon }}</v-icon>
      &nbsp;
      {{ snackbar.text }}
      <v-btn flat @click="snackbar.show = false">
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import XLSX from "xlsx";
import api from "@/api/axios/config";
import moment from "moment";

export default {
  props: {
    beforeUpload: Function, // eslint-disable-line
    onSuccess: Function // eslint-disable-line
  },
  data() {
    return {
      listLoading: false,
      loading: false,
      search: "",
      snackbar: {
        icon: "",
        text: "",
        color: "",
        show: false
      },
      excelData: {
        header: null,
        results: []
      },
      dataTable: {
        headers: [
          {
            text: "Agente",
            value: "agent_id"
          },
          {
            text: "Número de expediente",
            value: "num"
          },
          {
            text: "Tipo",
            value: "type"
          },
          {
            text: "Tipo de letrero",
            value: "sign_type"
          },
          {
            text: "Fecha de entrada",
            value: "date"
          },
          {
            text: "Documento probatorio adjunto",
            value: "attachment"
          },
          {
            text: "Fecha de vencimiento",
            value: "exp_date"
          },
          {
            text: "Estado",
            value: "status"
          },
          {
            text: "Observaciones",
            value: "observations"
          }
        ]
      }
    };
  },
  filters: {
    formatDate: function(date) {
      if (date != null && date != "") {
        return moment(date).format("DD/MM/YYYY");
      }
    }
  },
  methods: {
    generateData({ header, results }) {
      this.excelData.header = header;
      this.excelData.results = results;
      this.onSuccess && this.onSuccess(this.excelData);
    },
    handleDrop(e) {
      e.stopPropagation();
      e.preventDefault();
      if (this.loading) return;
      const files = e.dataTransfer.files;
      if (files.length !== 1) {
        this.$message.error("Only support uploading one file!");
        return;
      }
      const rawFile = files[0]; // only use files[0]
      if (!this.isExcel(rawFile)) {
        this.$message.error(
          "Only supports upload .xlsx, .xls, .csv suffix files"
        );
        return false;
      }
      this.upload(rawFile);
      e.stopPropagation();
      e.preventDefault();
    },
    handleDragover(e) {
      e.stopPropagation();
      e.preventDefault();
      e.dataTransfer.dropEffect = "copy";
    },
    handleUpload() {
      this.$refs["excel-upload-input"].click();
    },
    handleClick(e) {
      const files = e.target.files;
      const rawFile = files[0]; // only use files[0]
      if (!rawFile) return;
      this.upload(rawFile);
    },
    upload(rawFile) {
      this.$refs["excel-upload-input"].value = null; // fix can't select the same excel
      if (!this.beforeUpload) {
        this.readerData(rawFile);
        return;
      }
      const before = this.beforeUpload(rawFile);
      if (before) {
        this.readerData(rawFile);
      }
    },
    readerData(rawFile) {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => {
          const data = e.target.result;
          const fixedData = this.fixData(data);
          const workbook = XLSX.read(btoa(fixedData), { type: "base64" });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const header = this.getHeaderRow(worksheet);
          const results = XLSX.utils.sheet_to_json(worksheet);
          this.generateData({ header, results });
          this.loading = false;
          resolve();
        };
        reader.readAsArrayBuffer(rawFile);
      });
    },
    fixData(data) {
      let o = "";
      let l = 0;
      const w = 10240;
      for (; l < data.byteLength / w; ++l)
        o += String.fromCharCode.apply(
          null,
          new Uint8Array(data.slice(l * w, l * w + w))
        );
      o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w)));
      return o;
    },
    getHeaderRow(sheet) {
      const headers = [];
      const range = XLSX.utils.decode_range(sheet["!ref"]);
      let C;
      const R = range.s.r;
      /* start in the first row */
      for (C = range.s.c; C <= range.e.c; ++C) {
        /* walk every column in the range */
        const cell = sheet[XLSX.utils.encode_cell({ c: C, r: R })];
        /* find the cell in the first row */
        let hdr = "UNKNOWN " + C; // <-- replace with your desired default
        if (cell && cell.t) hdr = XLSX.utils.format_cell(cell);
        headers.push(hdr);
      }
      return headers;
    },
    isExcel(file) {
      return /\.(xlsx|xls|csv)$/.test(file.name);
    },
    save() {
      this.loading = true;
      if (this.excelData.results.length > 0) {
        api
          .post("gn/nueva-data", this.excelData.results)
          .then(response => {
            if (response.data.status) {
              this.snackbar = {
                icon: "check_circle",
                text: "¡Registros guardados con éxito!",
                color: "success",
                show: true
              };
            } else {
              this.snackbar = {
                icon: "error",
                text: "Ocurrió un error en el servidor...",
                color: "error",
                show: true
              };
            }
          })
          .catch(error => {
            this.snackbar = {
              icon: "error",
              text: error,
              color: "error",
              show: true
            };
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.snackbar = {
          icon: "error",
          text: "¡Debe seleccionar un archivo excel primero!",
          color: "warning",
          show: true
        };
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
.excel-upload-input {
  width: 100%;
  display: none;
  z-index: -9999;
}
.drop {
  border: 2px dashed #bbb;
  width: 100%;
  padding: 0.75rem;
  margin: 0 auto;
  font-size: 24px;
  border-radius: 5px;
  text-align: center;
  color: #bbb;
  position: relative;
}
</style>